import reportError from 'airship/modules/report-error'
import getDefaultSdk from 'airship/utils/web-sdk'

async function init(): Promise<void> {
  // this has side effects: grabbing a handle to the default SDK will initialize
  // the singleton SDK for the lifetime of this page load.
  await getDefaultSdk()
}

init().catch(reportError)
